import { EnvironmentSelector } from '@/shared/components/common/EnvironmentSelector'
import { useEnvironments } from '../hooks/useEnvironments'

interface ConnectedEnvironmentSelectorProps {
  className?: string
  onSettingsClick?: () => void
}

export function ConnectedEnvironmentSelector({
  className,
  onSettingsClick,
}: ConnectedEnvironmentSelectorProps) {
  const {
    currentEnvironment,
    environments,
    isLoading,
    error,
    onEnvironmentChange,
    onAddEnvironment,
    onRetry,
  } = useEnvironments()

  return (
    <EnvironmentSelector
      currentEnvironment={currentEnvironment}
      environments={environments}
      isLoading={isLoading}
      error={error}
      onEnvironmentChange={onEnvironmentChange}
      onAddEnvironment={onAddEnvironment}
      onSettingsClick={onSettingsClick}
      onRetry={onRetry}
      className={className}
    />
  )
}
